import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t, type IntlService } from 'ember-intl';
import { PhPiggyBank } from 'ember-phosphor-icons';
import BenefitCard from 'tio-employee/components/dashboard-kit/benefit-card';
import {
  SLR_WINDOW_DAYS,
  type SlrProgramSummary,
} from 'tio-employee/utils/partner-dashboard/sources/slr';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** Pertinent card: student loan repayment participants and recent contributions; nothing without a plan. */
export default class SlrProgramWidget extends Component<
  WidgetComponentSignature<SlrProgramSummary | null>
> {
  @service declare intl: IntlService;

  get contributed() {
    return this.intl.formatNumber((this.args.data?.contributedCents ?? 0) / 100, {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    });
  }

  <template>
    {{#if @data}}
      <BenefitCard
        @title={{t "partner_dashboard.slr.title"}}
        @icon={{PhPiggyBank}}
        data-test-partner-dashboard-slr-program
      >
        <dl class="grid grid-cols-1 gap-3 sm:grid-cols-[repeat(auto-fit,minmax(140px,1fr))]">
          <div class="tio-col-extra-tight" data-test-partner-dashboard-slr-stat="participants">
            <dt class="tio-text-sm-medium tio-fg-secondary">{{t
                "partner_dashboard.slr.participants"
              }}</dt>
            <dd class="tio-text-lg-semibold tio-fg-primary">{{@data.participants}}</dd>
          </div>
          <div class="tio-col-extra-tight" data-test-partner-dashboard-slr-stat="receiving">
            <dt class="tio-text-sm-medium tio-fg-secondary">{{t
                "partner_dashboard.slr.receiving"
              }}</dt>
            <dd class="tio-text-lg-semibold tio-fg-primary">{{@data.receiving}}</dd>
          </div>
          <div class="tio-col-extra-tight" data-test-partner-dashboard-slr-stat="contributed">
            <dt class="tio-text-sm-medium tio-fg-secondary">{{t
                "partner_dashboard.slr.contributed"
                days=SLR_WINDOW_DAYS
              }}</dt>
            <dd class="tio-text-lg-semibold tio-fg-primary">{{this.contributed}}</dd>
          </div>
        </dl>
        <p class="tio-text-sm-medium tio-fg-secondary">{{t
            "partner_dashboard.slr.recorded_note"
          }}</p>
      </BenefitCard>
    {{/if}}
  </template>
}
